import { useReadQuery } from '@apollo/client';
import { ButtonV2 } from '@synoptic/ui-kit/button-v2/button-v2.js';
import { Button } from '@synoptic/ui-kit/button/button.js';
import { useParams } from 'react-router';
import { ConnectionStatus } from '@/components/connection-status/connection-status';
import { ConnectionStatusType } from '@/components/connection-status/connection-status-type';
import { HighlightedFeedHeader } from '@/components/highlighted-feed-wrapper/highlighted-feed-header';
import { NewStreamPostModal } from '@/components/stream-post-card/new-stream-post-modal';
import { STREAM_CONNECTION_TOOLTIPS } from '@/components/streams/stream-connection-tooltips';
import { useRedesign } from '@/feature-flags/redesign/use-redesign.ts';
import {
  AuthenticatedStreamLoaderData,
  useStreamLoaderData,
} from '../_app.p.streams_.$id/loader';
import { useMe } from '../_app/use-me';
import { Route } from './+types/route';
import { useStreamPostsLoaderData } from './loader';
import { streamDataFiltersV2 } from './stream-data-v2.css.ts';
import { StreamPostsDateRange } from './stream-posts-date-range';
import { StreamPostsSearch } from './stream-posts-search';
import { connectionStatus } from './page.css';

export const StreamPostsAction = ({
  subscriptionStatus,
}: {
  subscriptionStatus: ConnectionStatusType;
}) => {
  const redesign = useRedesign();
  const { id: streamId } = useParams() as Route.ComponentProps['params'];
  const { hasFilter } = useStreamPostsLoaderData();
  const me = useMe();

  const { streamQueryRef } =
    useStreamLoaderData() as AuthenticatedStreamLoaderData;
  const { data } = useReadQuery(streamQueryRef);
  const stream = data?.stream;

  if (!stream) {
    return null;
  }

  const isMe = me.username === stream.author.username;
  const accessAllowed = isMe || stream.accessAllowed;

  if (!accessAllowed) {
    return null;
  }

  const filters = (
    <>
      {hasFilter ? (
        <div className={connectionStatus} />
      ) : (
        <ConnectionStatus
          subscriptionStatus={subscriptionStatus}
          tooltips={STREAM_CONNECTION_TOOLTIPS}
          containerClassName={connectionStatus}
        />
      )}
      <StreamPostsDateRange />
      <StreamPostsSearch />
      {isMe && !stream.customTargetsData ? (
        <NewStreamPostModal
          trigger={
            redesign ? (
              <ButtonV2 type="button" variant="secondary">
                Add new post
              </ButtonV2>
            ) : (
              <Button variant={'secondary'} size={'small'}>
                Add new post
              </Button>
            )
          }
          streamId={streamId}
        />
      ) : undefined}
    </>
  );

  if (redesign) {
    return <div className={streamDataFiltersV2}>{filters}</div>;
  }

  return <HighlightedFeedHeader>{filters}</HighlightedFeedHeader>;
};
